export default __webpack_public_path__ + "static/media/61-min.19becb2f.png";